<template>
    <div class="row spaceless tr">
        <div class="col-xs-12 col-sm-4 col-md-3 col-lg-2 td">
            <!--{% thumbnail image.original "200x200" upscale=False as thumb %}-->
            <a :href="product.catalogue_url">
                <img
                    class="thumbnail img-responsive image-left"
                    :src="product.image"
                    :alt="product.title"
                />
            </a>
        </div>
        <div class="col-xs-12 col-sm-8 col-md-9 col-lg-10 td">
            <a class="text-bold" :href="line.product.catalogue_url"
                >{{ gettext('Produktseite von') }} {{ product.title }}</a
            >
            <p v-html="product.description"></p>

            <table class="table-dl">
                <tbody>
                    <tr
                        v-for="(entry, index) in form_of_delivery_details"
                        :key="entry.field + index"
                    >
                        <th>
                            {{ entry.label }}
                        </th>
                        <td>
                            {{ booleanYesNo(entry.display_value) }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
const PACKAGING_UNIT_FIELD = 'packaging_unit_quantity'
const BUNDLE_UNIT_FIELD = 'bundle_unit_quantity'

export default {
    props: ['line'],
    data() {
        return {}
    },
    computed: {
        form_of_delivery_details() {
            return (this.line.product.form_of_delivery_details || []).map(
                (entry) => ({
                    ...entry,
                    label: this.getEntryLabel(entry),
                    display_value: this.getDisplayValue(entry),
                })
            )
        },
        product() {
            return this.line.product
        },
    },
    methods: {
        getEntryLabel(entry) {
            if (entry.field === PACKAGING_UNIT_FIELD) {
                return (
                    this.product.packaging_unit?.name ||
                    this.product.packaging_unit?.name_plural ||
                    this.product.trade_unit?.name ||
                    this.product.trade_unit?.name_plural ||
                    entry.name
                )
            }
            if (entry.field === BUNDLE_UNIT_FIELD) {
                return (
                    this.product.bundle_unit?.name ||
                    this.product.bundle_unit?.name_plural ||
                    entry.name
                )
            }
            return entry.name
        },
        getDisplayValue(entry) {
            if (
                ![PACKAGING_UNIT_FIELD, BUNDLE_UNIT_FIELD].includes(entry.field)
            ) {
                return entry.value
            }

            const quantity = this.parseUnitQuantity(entry.value)
            if (quantity === null || !this.product.trade_unit) {
                return entry.value
            }

            return `${this.formatUnitQuantity(
                quantity
            )} ${this.getTradeUnitName(quantity)}`
        },
        parseUnitQuantity(value) {
            if (value === null || value === undefined || value === '') {
                return null
            }

            const normalized = String(value).replace(',', '.').split(' ')[0]
            const quantity = Number.parseFloat(normalized)
            return Number.isNaN(quantity) ? null : quantity
        },
        formatUnitQuantity(quantity) {
            return quantity.toLocaleString('de-DE')
        },
        getTradeUnitName(quantity) {
            if (quantity === 1) {
                return (
                    this.product.trade_unit?.name ||
                    this.product.trade_unit?.name_plural ||
                    ''
                )
            }
            return (
                this.product.trade_unit?.name_plural ||
                this.product.trade_unit?.name ||
                ''
            )
        },
        booleanYesNo: function (value) {
            if (typeof value === 'boolean') {
                return value ? this.gettext('Ja') : this.gettext('Nein')
            } else {
                return value
            }
        },
    },
}
</script>

<style scoped></style>
